import React from "react";
import styled from "styled-components";
import { ProxiedRoutes } from "@lifeat/shared/system/RouteConstants";
import { UserType } from "@lifeat/shared/user/UserType";
import { useUserContext } from "@contexts/UserContext";
import ExploreTopNavigation from "./ExploreTopNavigation";

const ExplorePageContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
`;

const ExplorePageContentRow = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
`;

const StyledIframe = styled.iframe`
    height: 100% !important;
`;

export default function ExploreView() {
    const { userData } = useUserContext();

    return (
        <ExplorePageContainer className="info-page">
            <ExploreTopNavigation />
            <ExplorePageContentRow>
                <StyledIframe src={buildIframeSrc(userData?.userType)} />
            </ExplorePageContentRow>
        </ExplorePageContainer>
    );
}

function buildIframeSrc(userType?: UserType) {
    let src = new URL(ProxiedRoutes.Explore, location.href);
    if (userType) {
        // Webflow page uses this search param to personalize the explore view.
        src.searchParams.set("user-type", userType);
    }
    return src.toString();
}
